// export
export const piechartoptions = {
  maintainAspectRatio: false,
  legend: {
    display: true,
    position: 'bottom',
  },
  datalabels: {
    display: true,
    color: 'white',
  },
  elements: {
    arc: {
      borderWidth: 2,
    },
  },
}

export default { piechartoptions }
